export default __webpack_public_path__ + "static/media/404 -01.d3ccaa79.png";